export const mapInternalStateToPayload = state => {
  const {
    category,
    description,
    department,
    interview_template,
    languages = [],
    modules = {},
    name,
    profile: { categories = {}, outputVariables = {} } = {},
  } = state

  return {
    category,
    description,
    department,
    interview_template,
    languages,
    modules,
    name,
    profile: {
      categories,
      outputVariables,
    },
  }
}
